<!-- Data Table -->
<div class="data-table-container table-responsive">
  <table class="data-table table-bordered">
    <thead>
      <tr>
        <th
          *ngFor="let header of tableHeaders"
          [class.sortable]="isSortable(header)"
          [class.sorted]="isSorted(header)"
          (click)="onHeaderClick(header)"
        >
          <div
            class="table-header-container"
            [matTooltip]="header.header"
            matTooltipClass="table-header-tooltip"
          >
            <span class="header-text">{{ header.header }}</span>
            <mat-icon
              *ngIf="isSortable(header)"
              class="sort-icon"
              [class.active]="isSorted(header)"
            >
              {{ getSortIcon(header) }}
            </mat-icon>
          </div>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of tableData">
        <td *ngFor="let header of tableHeaders">
          {{ row[header.field] ?? "N/A" }}
        </td>
        <!-- <ng-template #statusCell>
            <div class="status-badge" [ngClass]="{'status-ongoing': row.status === 'Ongoing', 'status-resolved': row.status === 'Resolved'}">
              {{ row.status }}
            </div>
          </ng-template> -->
        <!-- <td>
            <div class="status-badge" [ngClass]="{'status-ongoing': row.status === 'Ongoing', 'status-resolved': row.status === 'Resolved'}">
              {{ row.status }}
            </div>
          </td> -->
      </tr>
    </tbody>
  </table>
</div>
